import { scrollToInvalidState } from './checkout';

const formRegistry: Record<string, { submitForm: () => Promise<void> }> = {};

export const registerForm = (id: string, submitForm: () => Promise<void>) => {
    formRegistry[id] = { submitForm };
};

export const unregisterForm = (id: string) => {
    delete formRegistry[id];
};

export const submitFormById = async (id: string, scroll?: boolean) => {
    if (formRegistry[id]) {
        await formRegistry[id].submitForm();

        scroll && scrollToInvalidState();
    } else {
        console.error(`Form with id "${id}" is not registered.`);
    }
};

export const submitAllForms = async () => {
    for (const id in formRegistry) {
        await formRegistry[id].submitForm();
    }
};
